import React from "react";
import { BaseScreen, BaseGrid, BaseToolbar, ITableColumn, ICrud } from "react-epharma-components/lib";
import { ExportTypes } from "react-epharma-components/lib/components/export";
import { NotificationTargetTypeLabels } from "@enums/NotificationTargetType";
import Helpers from "@helpers";
import Search from "./Search";
import CrudForm from "./Crud";

const NotificationRequestScreen: React.FC = (props) => {
  const ColumnsTableGrid: ITableColumn[] = [
    {
      name: "title",
      displayName: "Título",
      sortable: false,
    },
    {
      name: "body",
      displayName: "Mensagem",
      sortable: false,
    },
    {
      name: "targetType",
      displayName: "Enviado para",
      onRender: (value) => NotificationTargetTypeLabels[value as keyof typeof NotificationTargetTypeLabels],
    },
    {
      name: "createdAt",
      displayName: "Data do envio",
      type: "datetime",
    },
    {
      name: "author",
      displayName: "Envio por",
    },
  ];

  const crud: ICrud = {
    form: <CrudForm />,
    create: {
      show: true,
    },
    read: {
      show: true,
    },
    exportGrid: {
      show: false,
      types: [ExportTypes.csv],
    },
  };

  return (
    <BaseScreen title="Envio de mensagens Push Notification" description="">
      <BaseGrid
        name="recipe"
        baseEndpoint={Helpers.endpoints.appNotifications}
        toolbar={
          <BaseToolbar
            crud={crud}
            search={{
              show: true,
              form: <Search />,
            }}
          />
        }
        columns={ColumnsTableGrid}
        {...props}
      />
    </BaseScreen>
  );
};
export default NotificationRequestScreen;
